import { render, staticRenderFns } from "./BaseCell.vue?vue&type=template&id=44ca7223&scoped=true&"
import script from "./BaseCell.vue?vue&type=script&lang=js&"
export * from "./BaseCell.vue?vue&type=script&lang=js&"
import style0 from "./BaseCell.vue?vue&type=style&index=0&id=44ca7223&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca7223",
  null
  
)

export default component.exports